const hasWindow = typeof window !== 'undefined';
const location = hasWindow
  ? window.location
  : {
      hostname: '',
      search: '',
      origin: '',
      pathname: '',
    };
const searchParams = new URLSearchParams(location.search);

export const IS_LOCAL_ENV = !!location.hostname?.startsWith?.('localhost');

export const IS_LOCAL_BACKEND = searchParams.get('environment') === 'local';

export const ORIGIN_URL = location.origin;

export const IS_PROD_ENV =
  !IS_LOCAL_ENV &&
  !location.hostname?.startsWith?.('pre-www') &&
  !location.hostname?.startsWith?.('qa') &&
  !location.hostname?.startsWith?.('oneaudi-feature-app') &&
  !location.hostname?.includes?.('oneaudi-falcon-teams') &&
  !location.hostname?.includes?.('dev.collab') &&
  !location.hostname?.includes?.('prod.collab') &&
  searchParams.get('environment') !== 'development';

export const IS_TIER_1 =
  location.hostname.includes('audiusa.com') ||
  location.hostname.includes('audi.ca') ||
  location.pathname.includes('tier-1') ||
  (IS_LOCAL_ENV && !location.pathname.includes('tier-3'));

export const MARKET = searchParams.get('market');

export const ZIPCODE_DATA_LOCAL_STORAGE_KEY = 'ZipCodeData';

function resolveGraphqlGatewayUrl(): string {
  if (IS_PROD_ENV) return 'https://omnigraph.audi.com/graphql';
  if (IS_LOCAL_BACKEND) return 'http://localhost:9000/graphql';
  return 'https://qa-omnigraph.audi.com/graphql';
}
export const GRAPHQL_GATEWAY_URL = resolveGraphqlGatewayUrl();

// Date filter params - use asOfDate when BE deploys support, fallback to offerMonth for now
export const AS_OF_DATE = searchParams.get('asOfDate') ?? undefined;

export const OFFER_MONTH = searchParams.get('offerMonth') ?? undefined;

export const PARTNER_ID = searchParams.get('partner_id') ?? undefined;

export const GEO_ZIP_URL_PARAM = searchParams.get('geoZip') ?? undefined;
